import { Link } from "react-router-dom";
import { quickEntries } from "@/mocks/categories";

export default function QuickEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {quickEntries.map((entry, i) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group flex animate-fade-up items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 md:p-5"
          style={{ animationDelay: `${i * 60}ms` }}
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${entry.icon} text-2xl`}></i>
          </span>
          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">{entry.label}</h3>
            <p className="mt-1 text-xs leading-relaxed text-foreground-500">{entry.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}